import { inject } from '@angular/core'
import type { CanMatchFn } from '@angular/router'

import { FeatureFlag } from '../../environments/environment.interface'
import { FeatureFlagService } from '../services/feature-flag.service'

export const isDemoEnabled: CanMatchFn = (): boolean => {
  const featureFlagService = inject(FeatureFlagService)
  return featureFlagService.isEnabled(FeatureFlag.DEMO_PAGE)
}
